<template>
	<div class="mmf">
		<div class="mmf__modal">
			<!-- ////////////////////// -->
			<!-- HEADER -->
			<div class="mmf__modal-header">
				<div class="mmf__modal-header-title">Фильтры</div>
				<div class="mmf__modal-header-icon">
					<IconClose @click="onCloseModal" />
				</div>
			</div>

			<!-- ////////////////////// -->
			<!-- FORM -->
			<div class="mmf__modal-form">
				<!-- ~~~~~~~~~~~~~~~~~~ -->
				<!-- Партнёр. Dropdown -->
				<div class="mmf__modal-form-item" v-if="isShowPartner">
					<div class="mmf__modal-form-item-title">Партнёр</div>
					<UiMobileDropdownFilter
						label="Выбрать партнёра"
						:items="items.partners"
						v-on:filter="onPartnerFilter"
						:selected-id="partnerId"
					/>
				</div>

				<!-- ~~~~~~~~~~~~~~~~~~ -->
				<!-- Номер. Input -->
				<div class="mmf__modal-form-item">
					<div class="mmf__modal-form-item-title">Номер</div>
					<UiMobileInputFilter
						label="Введите номер"
						v-on:is-focus="onFocus"
						v-on:filter="onInstanceFilter"
						:selected-id="instanceId"
					/>
				</div>

				<!-- ~~~~~~~~~~~~~~~~~~ -->
				<!-- Токен. Input -->
				<div class="mmf__modal-form-item">
					<div class="mmf__modal-form-item-title">Токен</div>
					<UiMobileInputFilter
						label="Введите номер токена"
						v-on:is-focus="onFocus"
						v-on:filter="onTokenFilter"
						:selected-id="token"
					/>
				</div>

				<!-- ~~~~~~~~~~~~~~~~~~ -->
				<!-- Телефон. Input -->
				<div class="mmf__modal-form-item">
					<div class="mmf__modal-form-item-title">Телефон</div>
					<UiMobileInputFilter
						label="+7"
						v-on:is-focus="onFocus"
						v-on:filter="onPhoneFilter"
						:selected-id="phone"
					/>
				</div>

				<!-- ~~~~~~~~~~~~~~~~~~ -->
				<!-- Статус. Dropdown -->
				<div class="mmf__modal-form-item">
					<div class="mmf__modal-form-item-title">Статус</div>
					<UiMobileDropdownFilter
						label="Выберите статус"
						:items="statusFilterItems"
						v-on:filter="onStatusFilter"
						:selected-id="Number(statusId)"
					/>
				</div>

				<!-- ~~~~~~~~~~~~~~~~~~ -->
				<!-- Срок действия инстанса. Dropdown -->
				<div class="mmf__modal-form-item">
					<div class="mmf__modal-form-item-title">Срок действия</div>
					<UiMobileDropdownFilter
						label="Без сортировки"
						dropdown-default-label="Без сортировки"
						:items="expiredFilterItems"
						v-on:filter="onExpireOrder"
						:selected-id="Number(expireOrder)"
					/>
				</div>
			</div>

			<div v-if="isShowButton" class="mmf__modal-footer">
				<!-- RESET BUTTON -->
				<UiButton
					@click="onResetFilters"
					class="mmf__modal-footer-btn_reset"
					label="Отменить все фильтры"
					background-color="#c5c5c5"
					border-color="#c5c5c5"
					color="rgb(255, 255, 255)"
					font-weight="600"
					font-size="16px"
				/>

				<!-- ACCEPT FILTERS BUTTON -->
				<UiButton
					@click="onAcceptFilters"
					class="mmf__modal-footer-btn"
					label="Применить"
					background-color="var(--theme-color)"
					border-color="var(--theme-color)"
					color="rgb(255, 255, 255)"
					font-weight="600"
					font-size="16px"
				/>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import IconExit from "@/components/icons/IconExit.vue";
import IconClose from "@/components/icons/IconClose.vue";
import { mapActions } from "vuex";
import { IModal } from "@/interfaces/IModal";
import UiMobileDropdownFilter from "@/components/ui/mobile/UiMobileDropdownFilter.vue";
import UiMobileInputFilter from "@/components/ui/mobile/UiMobileInputFilter.vue";
import UiButton from "@/components/ui/UiButton.vue";
import { IInstance } from "@/interfaces/IInstance";

@Options({
	components: {
		UiButton,
		UiMobileInputFilter,
		UiMobileDropdownFilter,
		IconClose,
		IconExit,
	},

	props: {
		items: { type: Object, default: {} },
		channel: { type: String, default: "wapi" },
	},

	methods: {
		...mapActions("instanceModule", ["modalMobileFiltersAction"]),
	},
})
export default class ModalMobileFilters extends Vue {
	public items: IInstance;
	public channel: string;
	public isShowButton = true;

	// Filters
	public page = 1;
	public partnerId = 0;
	public instanceId = "";
	public token = "";
	public phone = "";
	public statusId = "";

	// Ordering
	public expireOrder = "";

	// ************************************************************
	// Define mapActions
	public modalMobileFiltersAction!: (payload: IModal) => void;

	public statusFilterItems = [
		{
			id: 1,
			name: "Активен",
		},
		{
			id: 2,
			name: "Ожидание",
		},
		{
			id: 6,
			name: "Остановлен",
		},
		{
			id: 10,
			name: "Удалён",
		},
	];

	public expiredFilterItems = [
		{
			id: 1,
			name: "Истекающие",
		},
		{
			id: 2,
			name: "Недавние",
		},
	];

	/**
	 * Hook mounted
	 */
	public mounted() {
		document.body.style.overflowY = "hidden";

		const partnerId = this.$route.query.partnerId;
		const instanceId = this.$route.query.instanceId as string;
		const token = this.$route.query.token as string;
		const phone = this.$route.query.phone as string;
		const statusId = this.$route.query.statusId as string;
		const expireOrder = this.$route.query.expireOrder as string;

		this.partnerId = partnerId !== undefined ? Number(partnerId) : 0;
		this.instanceId = instanceId !== "" ? instanceId : "";
		this.token = token !== "" ? token : "";
		this.phone = phone !== "" ? phone : "";
		this.statusId = statusId !== "" ? statusId : "";
		this.expireOrder = expireOrder !== "" ? expireOrder : "";
	}

	/**
	 * Закрываем модалку
	 */
	public onCloseModal() {
		document.body.style.overflowY = "auto";
		this.modalMobileFiltersAction({ isShow: false });
	}

	/**
	 * Применяем выбранные фильтры
	 */
	public onAcceptFilters() {
		this.performRequest();
		this.onCloseModal();
	}

	/**
	 * Сбрасываем все фильтры
	 */
	public onResetFilters() {
		this.partnerId = 0;
		this.instanceId = "";
		this.token = "";
		this.phone = "";
		this.statusId = "";
		this.expireOrder = "";

		this.performRequest();
		this.onCloseModal();
	}

	/**
	 * Удаляет ненужные символы из номера телефона
	 * Возвращает строку такого вида: 79142343450
	 * @param num
	 */
	public toSourcePhoneNumber(num: string) {
		const regExp = /\*|[()]|\+|-|\s|\$/g;

		return num.replace(regExp, "");
	}

	/**
	 * Если input в фокусе, тогда скрываем кнопку
	 * @param value
	 */
	public onFocus(value: boolean) {
		this.isShowButton = !value;
	}

	/**
	 * Обработка фильтра - Партнёр
	 * @param id
	 */
	public onPartnerFilter(id: number) {
		this.page = 1;
		this.partnerId = id;
	}

	/**
	 * Обработка фильтра - id инстанса
	 * @param id
	 */
	public onInstanceFilter(id: string) {
		this.page = 1;
		this.instanceId = id;
	}

	/**
	 * Обработка фильтра - token
	 * @param id
	 */
	public onTokenFilter(id: string) {
		this.page = 1;
		this.token = id;
	}

	/**
	 * Обработка фильтра - phone
	 * @param num
	 */
	public async onPhoneFilter(num: string) {
		this.page = 1;
		this.phone = this.toSourcePhoneNumber(num);
	}

	/**
	 * Обработка фильтра - status
	 * @param id
	 */
	public async onStatusFilter(id: string) {
		this.page = 1;
		this.statusId = id;
	}

	/**
	 * Обработка сортировки для поля - expire_payment_stamp
	 * all, asc, desc
	 * @param id
	 */
	public async onExpireOrder(id: string) {
		this.page = 1;
		this.expireOrder = id;
	}

	/**
	 * Выполняем запрос
	 */
	public performRequest() {
		const query = {
			page: this.page,
			partnerId: this.partnerId,
			instanceId: this.instanceId,
			token: this.token,
			phone: this.phone,
			statusId: this.statusId,
			// Активный канал приходит из вкладки родительской страницы.
			channel: this.channel,
			expireOrder: this.expireOrder,
		};

		this.$emit("selected-filters", query);
	}

	/**
	 * Скрываем или показываем колонку в таблице
	 * Возвращает true если больше 0
	 * Возвращает false если 0
	 */
	public get isShowPartner(): boolean {
		if (this.items.partners?.length !== undefined) {
			return this.items.partners?.length !== 0;
		}

		return false;
	}

}
</script>

<style scoped lang="scss">
.mmf {
	&__modal {
		display: block;
		position: fixed;
		z-index: 1;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		background-color: rgb(255, 255, 255);
		overflow-y: auto;
		scrollbar-width: thin;
	}

	&__modal-header {
		display: flex;
		padding: 12px 16px;
		align-items: center;
		justify-content: space-between;
		border-bottom: 1px solid rgb(236, 238, 251);
	}

	&__modal-header-title {
		font-size: 18px;
		font-weight: 600;
		color: rgb(49, 49, 50);
	}

	&__modal-header-icon {
		padding: 0 12px;
	}

	&__modal-form {
		padding: 16px;
	}

	&__modal-form-item {
		padding-bottom: 16px;
	}

	&__modal-form-item:last-child {
		padding-bottom: 100px;
	}

	&__modal-form-item-title {
		padding: 0 0 8px;
		color: rgb(49, 49, 50);
		font-size: 14px;
	}

	&__modal-footer {
		position: fixed;
		left: 16px;
		right: 16px;
		bottom: 16px;

		// Анимация
		animation-duration: 0.5s;
		animation-name: appearance-animation-search;
	}

	&__modal-footer-btn_reset {
		padding-bottom: 20px;
	}
}

@keyframes appearance-animation-search {
	0% {
		opacity: 0;
		transform: translate(0px, 30px);
	}
	100% {
		opacity: 1;
		transform: translate(0, 0);
	}
}
</style>
